import React from 'react';

import { DownloadIcon, ZoomInIcon } from '@vlabs/icons';
import { downloadImage } from '@vlabs/monokit/shared/lib/images';
import { FullFrameWithDetections } from '@vlabs/monokit/shared/ui/full-frame-with-detections';
import { ButtonScrimGroup, useModal } from '@vlabs/uikit';
import { IconButton } from '@vlabs/uikit/components/controls/button/icon-button/IconButton';

import st from './BaseVideoAnalyticsDetails.module.sass';

interface VideoAnalyticsFrameProps {
  detections: React.ComponentProps<typeof FullFrameWithDetections>['detections'];
  imageUrl?: string;
  withDetections: boolean;
}

export function VideoAnalyticsFrame({
  detections,
  imageUrl = undefined,
  withDetections,
}: VideoAnalyticsFrameProps): React.JSX.Element {
  const modal = useModal({ className: [st.FullFrameModal] });

  const frame = (
    <FullFrameWithDetections
      data-testid="workspace.analyticEventDetails.image"
      detections={detections}
      src={imageUrl}
      withDetections={withDetections}
    />
  );

  return (
    <React.Fragment>
      {modal.wrap(React.cloneElement(frame, { className: st.ModalFullFrame }))}

      <div className={st.ImageBlock}>
        {!!imageUrl && (
          <img
            alt="backgroundImage"
            className={st.BackgroundImage}
            role="presentation"
            src={imageUrl}
          />
        )}

        {frame}

        {!!imageUrl && (
          <ButtonScrimGroup
            className={st.Actions}
            size="small"
          >
            <IconButton
              data-testid="openFullScreenModalButton"
              icon={<ZoomInIcon />}
              kind="secondary"
              onClick={() => modal.open()}
              size="small"
              variant="flat"
            />
            <IconButton
              data-testid="workspace.analyticDetails.downloadButton"
              icon={<DownloadIcon />}
              kind="secondary"
              onClick={() => downloadImage(imageUrl)}
              size="small"
              variant="flat"
            />
          </ButtonScrimGroup>
        )}
      </div>
    </React.Fragment>
  );
}
